/* eslint-disable */
import * as util from "@/api/crm";

const state = {
    isShowForm: false,
    formParamTagSt: {
        id: "",
        name: "",
        description: "",
    },
};

const mutations = {
    SET_formParamTagSt: (state, value) => {
        state.formParamTagSt = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
};

const actions = {
    deleteTagSelected({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.deleteTagSelected(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    countContactByTagId({ commit }, tagId) {
        return new Promise((resolve, reject) => {
            util.countContactByTagId(tagId).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    unassignFromOneTag({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.unassignFromOneTag(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTagDetailByContactId({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.getTagDetailByContactId(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTagDetailByTagsId({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.getTagDetailByTagsId(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    assignContactToTag({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.assignContactToTag(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailTag({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detailTag(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createTag({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.createTag(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateTag({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.updateTag(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteTag({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.deleteTag(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    listTags({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listTags(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listTagsBC({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listTagsBC(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamTagSt({ commit }, data) {
        commit("SET_formParamTagSt", data);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/crm.js